import uuidv4 from 'uuid/v4';
import { get } from 'lodash/object';
import * as types from './mutation-types';
import * as authApi from '@/api/auth';

const PUMA_PLUGIN_PERMISSION_PREFIX = 'xtech_ext';
function flattenPermissions(permissions = []) {
    let res = {};
    permissions.forEach(p => {
        if (p.selected) {
            res[p.code] = p.name;
        }
        if (p.children && p.children.length > 0) {
            Object.assign(res, flattenPermissions(p.children));
        }
    });
    return res;
}

export async function reloadInitData({ commit, state, dispatch }) {
    let user;
    let products;
    try {
        user = await authApi.getUserInfo();
        products = await authApi.getProductsCanAccess(user.id);
    } catch (e) {
        console.error(e);
        return;
    }
    await dispatch('initData', { user, products });
}

export async function reloadProducts({ commit, state, dispatch }) {
    const userId = get(state, 'user.id', undefined);
    const products = await authApi.getProductsCanAccess(userId);
    await dispatch('setProductsCanAccess', products);
}

export async function initData({ commit, state, dispatch }, { user, products }) {
    commit(types.SET_USER_INFO, user);
    await dispatch('setProductsCanAccess', products);
}

export async function setProductsCanAccess({ commit, state }, products) {
    const _products = products.filter(p => p.productCode !== 'message_service' && p.productBoxTypeEnum !== 3);
    commit(types.SET_PRODUCTS_CAN_ACCESS_HASH, _products);
    commit(types.SET_PRODUCTS_CAN_ACCESS, _products);
}

export function setSessionId({ commit, state }) {
    commit(types.SET_SESSION_ID, uuidv4());
}

export function reset({ dispatch, commit, state }) {
    commit(types.RESET);
}

export function resetCrtProduct({ dispatch, commit, state }) {
    commit(types.RESET_CRT_PRODUCT);
}

export function setIsNeedSecondAuth({ dispatch, commit, state }, val = false) {
    commit(types.SET_IS_NEED_SECOND_AUTH, val);
}

// 这里将产品权限中的插件权限提取出来
export function setPluginPermissions({ dispatch, commit, state }, productPermissions = []) {
    let permissionsHash = flattenPermissions(productPermissions);
    let pluginPermissionsHash = {};
    Object.keys(permissionsHash).forEach(item => {
        if (item.startsWith(`${PUMA_PLUGIN_PERMISSION_PREFIX}`)) {
            pluginPermissionsHash[item] = permissionsHash[item];
        }
    });
    commit(types.SET_PLUGINS_PERMISSIONS, pluginPermissionsHash);
}

// 设置置灰
export function setIsGray({ dispatch, commit, state }, val = false) {
    commit('setIsGray', val);
}
